import React from "react";
import { Background } from "../../../BuildingBlocks/Background";
import { FrontColors } from "../../../../models/FrontColors";
import { TProbateLeadForm } from "../../../../../../domain/codecs/form/ProbateLeadForm";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FPSimpleLogo } from "../../Simple/FPSimpleLogo/FPSimpleLogo";
import { FPLandingTitle } from "../../Simple/FPLandingTitle/FPLandingTitle";
import { FPMarketingParagraph } from "../../Simple/FPMarketingParagraph/FPMarketingParagraph";
import { WeightBold } from "../../../WeightBold/WeightBold";
import { FPTwoBackgroundFullScreenView } from "../../Simple/FPTwoBackgroundFullScreenView/FPTwoBackgroundFullScreenView";
import { Shape } from "../../../BuildingBlocks/Shape";
import { FPMarketingParagraphColumn } from "../../Complex/FPMarketingParagraphColumn/FPMarketingParagraphColumn";
import { MaxWidth } from "../../../BuildingBlocks/MaxWidth";
import { FPMarketingHelplineCTA } from "../../Complex/FPMarketingHelplineCTA/FPMarketingHelplineCTA";

type TLandingPageDesktopWeAreProps = {
    form: TProbateLeadForm;
    onChange: (form: TProbateLeadForm) => void;
    onSubmit: (form: TProbateLeadForm) => void,
};

export const FPLandingPageDesktopWeAre = (props: React.PropsWithChildren<TLandingPageDesktopWeAreProps>): JSX.Element => {

    return (
        <FPTwoBackgroundFullScreenView
            leftColor={FrontColors.PROBATE_0}
            rightColor={FrontColors.PROBATE_0}
            leftCutPoint="50%"
            rightCutPoint="50%"
            height="auto"
        >
            <SpacingRow
                spacing={`79px`}
                childSize="1fr 2px 1fr"
                alignItems="flex-start"
            >
                {/* COLUMN - LEFT */}
                <Background 
                    backgroundPosition={"relative"}
                    padding={`180px 0px 210px`}
                >
                    <SpacingColumn spacing={`40px`}>

                        <SpacingRow justifyContent="center">
                            <FPSimpleLogo 
                                width={"95px"} 
                            />
                        </SpacingRow>
                        
                        <FPLandingTitle
                            color={FrontColors.NEUTRAL_18}
                            align="center"
                            size={56}
                        >
                            We Are <br/> Sail Probate
                        </FPLandingTitle>

                        <FPMarketingParagraph
                            color={FrontColors.NEUTRAL_18}
                            align="center"
                            size={20}
                        >
                            We give <WeightBold>free advice</WeightBold> with no <br/> <WeightBold>strings attached.</WeightBold> 
                        </FPMarketingParagraph>

                    </SpacingColumn>
                </Background>

                {/* BORDER */}
                <Background padding={`80px 0px`}>
                    <Shape 
                        width="2px"
                        height="700px"
                        color={FrontColors.NEUTRAL_10_2}
                    />
                </Background>

                {/* COLUMN - RIGHT */}
                <Background 
                    padding={`222px 0px 200px`}
                    width="480px"
                >
                    <SpacingColumn spacing="60px">
                        <FPMarketingParagraphColumn
                            size={22}
                            spacing="30px"
                            color={FrontColors.NEUTRAL_18}
                            paragraphs={[
                                <>We do this in the hope that if you like the <WeightBold>high level</WeightBold> of our <WeightBold>free service</WeightBold> you would chose to hire us.</>,
                                <>If not, no hard feelings.</>,
                                <>Enter your <WeightBold>number below</WeightBold> and we will <WeightBold>call you within 30 minutes*.</WeightBold></>
                            ]}
                        />

                        <MaxWidth width="350px">
                            <FPMarketingHelplineCTA
                                form={props.form}
                                coloursInverted={true}
                                autoFocus={false}
                                alignDisclaimer="left"
                                name="landing-page-0__we-are"
                                disclaimer="*we can only call you during regular working hours, and will never use your number for any other purpose."
                                onChange={props.onChange}
                                onSubmit={props.onSubmit}
                            />
                        </MaxWidth>
                    </SpacingColumn>
                </Background>
            </SpacingRow>
        </FPTwoBackgroundFullScreenView>
    );
};
